import { render, staticRenderFns } from "./ModalExclusaoFiltro.vue?vue&type=template&id=60d4e74e&"
import script from "./ModalExclusaoFiltro.vue?vue&type=script&lang=js&"
export * from "./ModalExclusaoFiltro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports